import { z } from 'zod';
import { PartnerContactSchema } from '../../entities/partner/partner-contact.schema';
/**
 * List Partner Contacts Response
 * GET /api/v2/partner/contacts
 */ export const ListPartnerContactsResponseSchema = z.object({
    data: z.array(PartnerContactSchema)
});

//# sourceMappingURL=list-partner-contacts.schema.js.map